module.exports = __webpack_public_path__ + "static/media/Assets-08-Visualising-epilepsy-halftone.c57807bd.jpg";